<template>
  <div class="overflow-y-auto">
    <table class="w-full border-collapse bg-white text-sm [&_td]:h-20">
      <thead>
        <tr class="text-left border-b border-gray-300 h-12">
          <th class="py-1 w-12"></th>
          <th class="px-2 py-1 font-medium text-xs text-gray-500">Candidate</th>
          <th class="px-2 py-1 font-medium text-xs text-gray-500">Role</th>
          <th class="px-2 py-1 font-medium text-xs text-gray-500">Company</th>
          <th class="px-2 py-1 font-medium text-xs text-gray-500">Status</th>
          <th class="px-2 py-1 font-medium text-xs text-gray-500">Last Updated</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="i in 6" :key="i" class="border-b border-gray-300">
          <td class="py-1 text-center w-12">
            <div class="h-4 w-6 bg-gray-200 rounded animate-pulse mx-auto"></div>
          </td>
          <td class="px-2 py-1 w-48">
            <div class="flex flex-col gap-1">
              <div class="h-5 w-40 bg-gray-200 rounded animate-pulse"></div>
              <div class="h-4 w-44 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </td>
          <td class="px-2 py-1">
            <div class="flex flex-col gap-2">
              <div class="flex gap-1">
                <div class="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
                <div class="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
              </div>
              <div class="flex gap-1">
                <div class="h-5 w-28 bg-gray-200 rounded-full animate-pulse"></div>
                <div class="h-5 w-28 bg-gray-200 rounded-full animate-pulse"></div>
              </div>
            </div>
          </td>
          <td class="px-2 py-1 max-w-72">
            <div class="h-10 w-full bg-gray-200 rounded-full animate-pulse"></div>
          </td>
          <td class="px-2 py-1">
            <div class="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
